export const productTypes = {
    GET_ALLPRODUCTS: "GET_ALLPRODUCTS",

}